module.exports = __webpack_public_path__ + "fonts/ubuntu-v14-latin-regular.d270e00.ttf";